// removed by extract-text-webpack-plugin
module.exports = {"weekControl":"styles__weekControl___18djg","timesheetButton":"styles__timesheetButton___HZjd2"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/weekControl/styles.scss
// module id = 482
// module chunks = 0